import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'

import styles from './ErrorPage.module.scss'

export default React.memo(function ErrorPage() {
  const { t } = useTranslation()

  const error = useRouteError() as any

  const msg = error?.message || 'Oops.'

  return (
    <article className={styles.ErrorPage}>
      <div className={styles.friendlyError}>
        <h1>{msg}</h1>
        <a href="/">{t('back to homepage')}</a>
      </div>

      {process.env.NODE_ENV !== 'production' && <pre>{error?.stack}</pre>}
    </article>
  )
})
